module.exports = "<iframe id=\"player\" type=\"text/html\" class=\"col-md-10\"  [src]=getSantizeUrl(track.urlVideo)  frameborder=\"0\"></iframe>\r\n\r\n \r\n"